import type { MonitoringPort } from '@/core/ports/external';

export const noopMonitoring: MonitoringPort = {
  captureException() {},
  captureMessage() {},
  log() {},
  setUser() {},
  clearUser() {},
  setTag() {},
  setContext() {},
  async flush() {
    return true;
  },
};
